// Textos del listado y la edición de usuarios WAIIS (user-list). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'en',
  data: {
    WAIIS_USER_LIST: {
      EXPORT_CSV: 'Export CSV',
      KPIS: {
        ARIA: 'User indicators',
        TOTAL: 'Total users',
        TOTAL_HINT: 'Accounts registered in the app',
        NEW_7D: '+{{count}} in the last 7 days',
        ACTIVE_30D: 'Active (30 days)',
        ACTIVE_30D_HINT: 'Opened the app in the last month',
        DRIVERS: 'Drivers',
        DRIVERS_HINT: 'With a registered vehicle',
        BANNED: 'Blocked',
        BANNED_HINT: 'Accounts blocked by the team',
        SHARE_OF_TOTAL: '{{pct}} of total',
        IN_TABLE: 'In the table',
        SEE_IN_TABLE: 'View in table',
      },
      FILTERS: {
        SEARCH_PLACEHOLDER: 'Search name, email, phone or ID…',
        SEARCH_ARIA: 'Search user',
        TYPE_ARIA: 'Type',
        STATUS_ARIA: 'Status',
        ACTIVITY_ARIA: 'Activity',
        CLEAR: 'Clear filters',
        TYPE: {
          ALL: 'Type: all',
          DRIVER: 'Drivers',
          NO_DRIVER: 'No vehicle',
          ADMIN: 'Administrators',
        },
        STATUS: {
          ALL: 'Status: all',
          NOT_BANNED: 'Not blocked',
          BANNED: 'Blocked',
        },
        ACTIVITY: {
          ALL: 'Activity: any',
          TODAY: 'Today',
          LAST_7D: 'Last 7 days',
          LAST_30D: 'Last 30 days',
          INACTIVE_30D: 'No activity in 30 days',
        },
      },
      PANEL: {
        TITLE_DRIVERS: 'Drivers',
        TITLE_DRIVERS_BANNED: 'Blocked drivers',
        TITLE_NO_DRIVER: 'Users without a vehicle',
        TITLE_ADMINS: 'Administrators',
        TITLE_BANNED: 'Blocked users',
        TITLE_ACTIVE_30D: 'Active users (30 days)',
        TITLE_ALL: 'Registered users',
        PART_ACTIVITY: 'activity: {{value}}',
        PART_SEARCH: 'search “{{value}}”',
        SUB_FILTERED: 'Filtered by {{filters}}. Click a row to open the user’s profile.',
        SUB_ALL: 'All accounts registered in the app. Click a row to open the user’s profile.',
      },
      TABLE: {
        LOADING: 'Loading…',
        LOADING_USERS: 'Loading users',
        COL_CREATED: 'Signed up',
        COL_USER: 'User',
        COL_PHONE: 'Phone',
        COL_ROLE: 'Role',
        COL_VERIFICATION: 'Verification',
        COL_LAST_ACTIVITY: 'Last activity',
        COL_STATUS: 'Status',
        COL_OPEN: 'Open',
        VIEW_PROFILE: 'View profile',
        RETRY: 'Retry',
        EMPTY_FILTERED: 'No users match your search.',
        EMPTY: 'There are no users yet.',
        NO_ACTIVITY_RECORDED: 'No activity recorded',
        NO_NAME: 'No name',
      },
      ERRORS: {
        INVALID_FILTER: 'One of the filters is not valid. Try clearing the filters.',
        LOAD: 'The user list could not be loaded.',
      },
      PAGINATION: {
        SHOWING_ONE: 'Showing {{shown}} of {{total}} user',
        SHOWING_OTHER: 'Showing {{shown}} of {{total}} users',
        PREV: 'Previous',
        NEXT: 'Next',
        PREV_ARIA: 'Previous page',
        NEXT_ARIA: 'Next page',
        PER_PAGE: '{{count}} per page',
        PER_PAGE_ARIA: 'Users per page',
      },
      ROLE: {
        ADMIN: 'Admin',
        BUSINESS: 'Business',
        APP: 'App',
      },
      STATUS: {
        BANNED: 'Blocked',
        ACTIVE: 'Active',
      },
      CHECKS: {
        PHONE_ON: 'Phone verified',
        PHONE_OFF: 'Phone not verified',
        DOCUMENT_ON: 'ID document verified',
        DOCUMENT_OFF: 'ID document not verified',
        LICENSE_ON: 'Driving licence verified',
        LICENSE_OFF: 'Driving licence not verified',
      },
      AGO: {
        NEVER: 'Never',
        NOW: 'Just now',
        MINUTES: '{{count}} min ago',
        HOURS: '{{count}} h ago',
        YESTERDAY: 'Yesterday',
        DAYS: '{{count}} days ago',
        MONTHS_ONE: '1 month ago',
        MONTHS_OTHER: '{{count}} months ago',
        OVER_YEAR: 'Over a year ago',
      },
    },
    USER_EDIT: {
      TITLE: 'Edit user',
      SUBTITLE: 'User account details.',
      SUBTITLE_WHO: 'Account details for {{name}}.',
      BACK: 'Back to profile',
      LOADING: 'Loading user',
      CANCEL: 'Cancel',
      SAVE: 'Save changes',
      SAVING: 'Saving…',
      SECTIONS: {
        PERSONAL: 'Personal details',
        PERSONAL_SUB: 'Name and basic details of the person.',
        CONTACT: 'Contact and account',
        CONTACT_SUB: 'How they sign in to the app and which language they use.',
        DOCUMENT: 'Document',
        DOCUMENT_SUB: 'ID document and CAE.',
        PROFESSIONAL: 'Professional profile',
        PROFESSIONAL_SUB: 'What other members of the community see.',
        PREFERENCES: 'Preferences',
        PREFERENCES_SUB: 'Subscriptions and account status.',
      },
      FIELDS: {
        NAME: 'First name',
        SURNAME: 'Last name',
        GENDER: 'Gender',
        BIRTH_DATE: 'Date of birth',
        EMAIL: 'Email',
        PHONE: 'Phone',
        ROLE: 'Role',
        LANGUAGE: 'Language',
        DOCUMENT_TYPE: 'Document type',
        DOCUMENT: 'Document',
        CAE: 'CAE',
        PROFESSION: 'Profession',
        RELATED_COMPANY: 'Related company',
        LINKEDIN: 'LinkedIn URL',
        DESCRIPTION: 'Description',
        SUBSCRIBE: 'Subscribe',
        NEWSLETTER: 'Subscribed to the newsletter',
        AVAILABLE: 'Available',
        VIRTUAL: 'Virtual',
      },
      SELECT: {
        ROLE: 'Select a role',
        LANGUAGE: 'Select a language',
        GENDER: 'Select a gender',
        DOCUMENT_TYPE: 'Select a type',
      },
      ROLES: {
        DRIVER_PARTICULAR: 'Private driver',
        DRIVER_COMPANY: 'Company driver',
        ADMIN: 'Administrator',
        LOGISTICS: 'Logistics',
      },
      GENDERS: {
        M: 'Male',
        F: 'Female',
        O: 'Other',
      },
      DOCUMENT_TYPES: {
        DNI: 'DNI',
        NIE: 'NIE',
        PASSPORT: 'Passport',
      },
      ERRORS: {
        REQUIRED: '{{field}} is required',
        MIN_LENGTH: '{{field}} must be at least {{min}} characters long',
        EMAIL: 'Enter a valid email',
        PATTERN: '{{field}} has an invalid format',
        INVALID: 'Invalid field',
        ROLE_REQUIRED: 'Role is required',
        LANGUAGE_REQUIRED: 'Language is required',
      },
      SWAL: {
        SUCCESS_TITLE: 'User updated',
        SUCCESS_TEXT: 'The changes have been saved.',
        ERROR_TITLE: 'The changes could not be saved',
        LOAD_DATA_ERROR: 'Error loading the user’s details',
        LOAD_ERROR: 'Error loading the user',
        UPDATE_ERROR: 'Error updating the user',
      },
    },
  },
};
